import { createSlice } from '@reduxjs/toolkit'
import { clearLocation, setLocation } from '../reducers/locationReducers'

export type LocationState = {
  id: string
  name: string
  contactName: string
  contactPhone: string
  contactEmail: string
}

const initialState: LocationState = {
  id: '',
  name: '',
  contactName: '',
  contactPhone: '',
  contactEmail: '',
}

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    clearLocation,
    setLocation,
  },
})

export const locationActions = locationSlice.actions
export default locationSlice.reducer
